import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Config } from './config';
import { Color } from '../Models/color';
import { Observable } from 'rxjs/Observable';
import { LanguageService } from './lang';


@Injectable()
export class ColorService {

  constructor(private http: HttpClient,
              private config: Config,
              private languageService: LanguageService) { }

  list(): Observable<Color[]> {
    // colors depend on language hence the flatmap
    return this.languageService.getLanguage().flatMap(
      value => {
        return this.http.get<Color[]>(this.config.getURL('colors'));
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Services/color.ts